export const donorRecipientConstants = {
    // Add and editing donor recipient
    SAVING_DONOR_RECIPIENT_REQUEST: 'SAVING_DONOR_RECIPIENT_REQUEST',
    SAVING_DONOR_RECIPIENT_SUCCESS: 'SAVING_DONOR_RECIPIENT_SUCCESS',
    SAVING_DONOR_RECIPIENT_FAILURE: 'SAVING_DONOR_RECIPIENT_FAILURE',

    // Loading donor recipients
    LOAD_DONOR_RECIPIENTS_REQUEST: 'LOAD_DONOR_RECIPIENTS_REQUEST',
    LOAD_DONOR_RECIPIENTS_SUCCESS: 'LOAD_DONOR_RECIPIENTS_SUCCESS',
    LOAD_DONOR_RECIPIENTS_FAILURE: 'LOAD_DONOR_RECIPIENTS_FAILURE',

    // Delete donor recipient
    DELETE_DONOR_RECIPIENT_REQUEST: 'DELETE_DONOR_RECIPIENT_REQUEST',
    DELETE_DONOR_RECIPIENT_SUCCESS: 'DELETE_DONOR_RECIPIENT_SUCCESS',
    DELETE_DONOR_RECIPIENT_FAILURE: 'DELETE_DONOR_RECIPIENT_FAILURE',

    // Loading donor recipient link progresses
    LOAD_DONOR_RECIPIENT_PROGRESSES_REQUEST: 'LOAD_DONOR_RECIPIENT_PROGRESSES_REQUEST',
    LOAD_DONOR_RECIPIENT_PROGRESSES_SUCCESS: 'LOAD_DONOR_RECIPIENT_PROGRESSES_SUCCESS',
    LOAD_DONOR_RECIPIENT_PROGRESSES_FAILURE: 'LOAD_DONOR_RECIPIENT_PROGRESSES_FAILURE',

    // Send donor recipient link progress update
    SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_REQUEST: 'SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_REQUEST',
    SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_SUCCESS: 'SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_SUCCESS',
    SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_FAILURE: 'SEND_DONOR_RECIPIENT_PROGRESS_UPDATE_FAILURE',
}



// WEBPACK FOOTER //
// ./src/redux/constants/donorRecipient.constants.js